import { Reducer } from 'redux';
import {
  CallStatsAction,
  CallStatsActionTypes,
  CallStatsStore,
  Panel,
} from './callStatsTypes';

const emptyPanel = <T>(): Panel<T> => ({
  loading: false,
  error: null,
  data: null,
  mocked: false,
});

export const initialCallStatsState: CallStatsStore = {
  filters: { window: '1d' },
  summary: emptyPanel(),
  byUser: emptyPanel(),
  pair: emptyPanel(),
  failures: emptyPanel(),
  connectivity: emptyPanel(),
  scores: emptyPanel(),
  byDimension: emptyPanel(),
  calls: emptyPanel(),
  callDetail: emptyPanel(),
};

const callStatsReducer: Reducer<CallStatsStore, CallStatsAction> = (
  state = initialCallStatsState,
  action,
) => {
  switch (action.type) {
    case CallStatsActionTypes.SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case CallStatsActionTypes.PANEL_REQUEST: {
      const { key } = action.payload;
      return {
        ...state,
        [key]: { ...state[key], loading: true, error: null },
      };
    }

    case CallStatsActionTypes.PANEL_SUCCESS: {
      const { key, data, mocked } = action.payload;
      return {
        ...state,
        [key]: { loading: false, error: null, data, mocked },
      };
    }

    case CallStatsActionTypes.PANEL_FAILURE: {
      const { key, error } = action.payload;
      return {
        ...state,
        [key]: { ...state[key], loading: false, error },
      };
    }

    default:
      return state;
  }
};

export default callStatsReducer;
